import { decodeJwt } from '@/features/auth/utils/jwtUtils';

/**
 * How the app session changed when another tab of the same browser wrote the
 * shared access token:
 * - `signed-out`: the other tab closed the session.
 * - `signed-in`: there was no session and the other tab opened one.
 * - `account-changed`: another person, or another company of the same person.
 * - `unchanged`: the same membership renewed its token.
 */
export type SessionChange = 'signed-out' | 'signed-in' | 'account-changed' | 'unchanged';

type SessionClaims = { sub?: string; firebase_uid?: string };

function sessionOwner(token: string): string {
  const claims = decodeJwt<SessionClaims>(token);
  return `${claims?.firebase_uid ?? ''}:${claims?.sub ?? ''}`;
}

export function classifySessionChange(previousToken: string | null, nextToken: string | null): SessionChange {
  if (!nextToken) return previousToken ? 'signed-out' : 'unchanged';
  if (!previousToken) return 'signed-in';
  return sessionOwner(previousToken) === sessionOwner(nextToken) ? 'unchanged' : 'account-changed';
}
